import { tickerItems } from '@/mocks/feed';

const heroStats = [
  { label: '持续追踪线索', value: '4,812' },
  { label: '深度专题', value: '236' },
  { label: '幕后推手档案', value: '97' },
];

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20editorial%20background%20with%20deep%20charcoal%20smoke%20and%20a%20warm%20crimson%20spotlight%20glow%2C%20scattered%20film%20grain%20and%20torn%20paper%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20high%20contrast%20negative%20space%20in%20the%20upper%20center%20for%20typography%2C%20cinematic%20magazine%20cover%20aesthetic%2C%20no%20text%2C%20no%20people&width=1600&height=1000&seq=bao-hero-01&orientation=landscape"
          alt="17爆料网深挖特辑主视觉"
          title="17爆料网 行业黑幕深挖特辑"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/85" />

      <div className="relative z-10 mx-auto w-full max-w-[1400px] px-4 pb-0 pt-16 md:px-8 md:pt-24">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/10 px-4 py-1.5 text-[11px] font-medium uppercase tracking-[0.24em] text-accent-200">
            <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-accent-400" />
            2026 秋季 · 深挖特辑
          </span>

          <h1 className="mt-6 max-w-4xl font-heading text-3xl font-bold leading-[1.25] tracking-tight text-background-50 md:text-[56px] md:leading-[1.18]">
            17爆料网 · 看见表层之下的
            <span className="text-primary-300">真实逻辑</span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-foreground-200 md:text-base">
            从娱乐圈内幕到网红圈潜规则，从饭圈操作到资本运作，我们把散落的线索、报价单与时间线摆在一起，
            整理成一条可被阅读、可被追问的行业黑幕叙事。
          </p>

          <div className="mt-9 flex w-full flex-col items-stretch justify-center gap-3 sm:w-auto sm:flex-row sm:items-center">
            <a
              href="#feed"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-flashlight-line text-base" />
              进入今日快讯
            </a>
            <a
              href="#deepdive"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-bookmark-line text-base" />
              阅读封面深挖
            </a>
          </div>

          <div className="mt-12 grid w-full max-w-3xl grid-cols-1 gap-3 sm:grid-cols-3">
            {heroStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-50/10 bg-background-50/5 px-5 py-4 text-center backdrop-blur-sm"
              >
                <p className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{stat.value}</p>
                <p className="mt-1 text-[11px] tracking-[0.16em] text-foreground-300">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex items-center gap-4 border-t border-background-50/10 py-4">
          <span className="flex shrink-0 items-center gap-2 whitespace-nowrap text-[11px] font-medium tracking-[0.2em] text-primary-300">
            <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-primary-400" />
            快讯速报
          </span>
          <div className="relative w-full overflow-hidden">
            <div className="flex w-max animate-marquee items-center">
              {[...tickerItems, ...tickerItems].map((item, index) => (
                <span
                  key={`${item}-${index}`}
                  className="mr-8 flex shrink-0 items-center gap-3 whitespace-nowrap text-[13px] text-foreground-200"
                >
                  <i className="ri-price-tag-3-line text-accent-400" />
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}